(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["market-country-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('market-country-selector')) {
    customElements.define(
      'market-country-selector',
      class extends HTMLElement {
        connectedCallback() {
          const select = this.querySelector('select[name="country_code"]');

          if (select) {
            select.addEventListener('change', () => select.form.submit());
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
